import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from "@mui/material";

const EmailTemplateView = ({ templateBody, open, onOpenChange }) => {
  return (
    <Dialog
      open={open}
      onClose={() => onOpenChange(false)}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle sx={{ fontWeight: "bold", fontSize: "1.5rem" }}>Email Template</DialogTitle>

      <DialogContent
        dividers
        sx={{
          maxHeight: "80vh",
          overflowY: "auto",
          paddingX: 3,
          paddingY: 2,
        }}
      >
        <Box dangerouslySetInnerHTML={{ __html: templateBody }} />
      </DialogContent>

      <DialogActions sx={{ padding: 2, justifyContent: "flex-end" }}>
        <Button
          variant="outlined"
          onClick={() => onOpenChange(false)}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmailTemplateView;
